import _ from 'underscore'
var plugin = {
  key: 'vue-local-key',
  flash_key: 'vue-local-flash-key',
  setAll: function (all) {
    window.localStorage.setItem(plugin.key, JSON.stringify(all))
  }
}

plugin.install = function (Vue, options) {
  Vue.prototype.$local = {
    flash: {
      parent: function () {
        return Vue.prototype.$local
      },
      get: function (key) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}
        var flash_value = all_flash[key]
        return flash_value
      },
      set: function (key, value) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}

        all_flash[key] = value
        all[plugin.flash_key] = all_flash

        plugin.setAll(all)
      },
      remove: function (key) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}
        delete all_flash[key]
        all[plugin.flash_key] = all_flash
        plugin.setAll(all)
      }
    },
    getAll: function () {
      var all = JSON.parse(window.localStorage.getItem(plugin.key))
      return all || {}
    },
    set: function () {
      var _set = (key, value) => {
        if (key == 'local-id') return false
        var all = this.getAll()
        if (!('local-id' in all)) {
          this.start()
          all = this.getAll()
        }
        all[key] = value
        plugin.setAll(all)
      }
      if (arguments.length == 1) {
        var o = arguments[0]
        _.each(o, (value, key) => {
          _set(key, value)
        })
      } else if (arguments.length == 2) {
        _set(arguments[0], arguments[1])
      }
    },
    get: function () {
      var all = this.getAll()
      if (arguments.length == 1) {
        return all[arguments[0]]
      } else {
        return _.pick(all, arguments)
      }
    },
    pick: function () {
      var all = this.getAll()
      var param = _.union([all], arguments)
      return _.pick.apply(_, param)
    },
    start: function () {
      var all = this.getAll()
      all['local-id'] = 'sess:' + Date.now()

      plugin.setAll(all)
    },
    exists: function () {
      var all = this.getAll()
      return 'local-id' in all
    },
    has: function (key) {
      var all = this.getAll()
      return key in all
    },
    remove: function (key) {
      var all = this.getAll()
      delete all[key]
      plugin.setAll(all)
    },
    clear: function () {
      var all = this.getAll()
      plugin.setAll({ 'local-id': all['local-id'] })
    },
    destroy: function () {
      plugin.setAll({})
    },
    id: function () {
      return this.get('local-id')
    },
    url: function() {
      if (window.location.href.indexOf("doc.mding.org")>-1 ||
        window.location.href.indexOf("localhost")>-1||
        window.location.href.indexOf("127.0.0.1")>-1 ||
        window.location.href.indexOf("192.168.")>-1 ||
        window.location.href.indexOf("file://")>-1){
          return "https://dev.mding.org/mtea"
        }else {
          return "https://tea.api.mding.org/mtea"
        }
    },
    pushUrl: function () {
      if (window.location.href.indexOf("doc.mding.org")>-1 ||
        window.location.href.indexOf("localhost")>-1||
        window.location.href.indexOf("127.0.0.1")>-1 ||
        window.location.href.indexOf("192.168.")>-1 ||
        window.location.href.indexOf("file://")>-1){
          return "https://dev.push.mding.org/"
        }else {
          return "https://tea.push.mding.org/"
        }
    }
  }
}
export default plugin
export const install = plugin.install
